import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import their parent route from routes.tsx, which imports this module back into the tree; the same cycle already exists for every migrated route (see the workflow Memories and runs tabs).
import { backgroundAgentsLayoutRoute } from 'src/routes';

// Explicit-version view of a procedure (AI-461): `/agents/procedures/$id/v/$versionNumber`.
// Renders the same detail page as `/agents/procedures/$id`; the page reads the optional
// `versionNumber` param (`useParams({ strict: false })`) to decide which version to load —
// matching the workflow convention where the bare URL is the published version and `/v/N` is an
// explicit one.
export const Route = createRoute({
  getParentRoute: () => backgroundAgentsLayoutRoute,
  path: 'procedures/$id/v/$versionNumber',
  component: lazyRouteComponent(
    () => import('../../../../../operator/OperatorSopDetailPage'),
    'OperatorSopDetailPage',
  ),
  loader: () => ({
    crumb: msg('Procedure', { context: 'page breadcrumb' }),
    crumbTo: '/agents/procedures',
  }),
  validateSearch: z.object({ agentId: z.string().optional() }),
});
